<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'管理员电话 / 管理员名称 / 角色名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;param.isshow=true;}
                        if(val.type=='keydown') GetManagerInfo();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetManagerInfo()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增管理员'}" @finish="AddManager()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'管理员角色管理'}" @finish="ManagerRole()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-manager-obj">
        <el-table :data="managerlist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="序号" type="index" min-width="50" align="center" />
            <el-table-column label="管理员头像" align="center" v-if="pagelabel.thumb">
                <template #default="scope">
                    <wcimage :value="scope.row.thumb" :option="{size:'middle'}" />
                </template>
            </el-table-column>
            <el-table-column label="管理员名称" prop="name" align="center" v-if="pagelabel.name"/>
            <el-table-column prop="phone" label="管理员手机" align="center" v-if="pagelabel.phone"/>
            <el-table-column label="管理员角色" prop="groupname" align="center" v-if="pagelabel.groupname"/>
            <el-table-column prop="inputtime" label="添加时间" align="center" v-if="pagelabel.inputtime"/>
            <el-table-column label="是否创始人" align="center" v-if="pagelabel.isNo1">
                <template #default="scope">{{scope.row.isNo1==1 ? '是' : '否'}}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="130">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditManager(scope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelManager(scope.row.id)" class="left10" />
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetManagerInfo();
                    }"
                />
            </div>
        </div>
    </div>


    <!-- 角色管理 -->
    <ManagerRole :value="roleshow" @rollback="GetRoleRollback" />

    <!-- 页面标签 -->
    <Pagelabel :value="showpagelabel" :type="'manager'" 
        @finish="(val)=> {
            showpagelabel=false;
            Getpagelabel(true);
        }" 
    />


</template>

<script>
import Pagelabel from '@/views/System/Pagelabel';
import INTERFACE_MODEL_MANAGER from '@/Interface/manager/manager';
import ManagerRole from '@/views/Manager/ManagerRole';  //角色管理
export default {
    components:{
        ManagerRole,Pagelabel
    },
    data() {
        return {
            showpagelabel:false,
            pagelabel:{},
            param: {
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            managerlist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除管理员'},
                {id:2,name:'批量修改管理员'},
            ],

            roleshow:false,

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            this.showpagelabel=true;
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.Getpagelabel();      //获取页面显示标签信息
            this.GetManagerInfo();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetManagerInfo();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetManagerInfo();
            }else {
                this.GetManagerInfo();
            }
        },


        /** 数据批操作处理 **/
        changehandle(index) {
            this.handlevalue='';
            var ids=this.GetSelectDataIds();
            if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的管理员',type:'warning'});return false;}
            ids=ids.join(',');

            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                if(index==1) {
                    this.DelManagermores(ids);
                }else if(index==2) {
                    this.EditManagerInfos(ids);
                }
               
            }).catch(()=> {
                
            });
        },



        /** 删除管理员 **/
        DelManager(id) {
            this.DelManagermores(id);
        },

        
        /** 删除管理员信息操作 **/
        DelManagermores(ids) {
            INTERFACE_MODEL_MANAGER.DEL_MANAGER({ids:ids}).then((res) => {
                if(res.status > 0) return false;
                this.GetManagerInfo();
            });
        },


        /** 编辑管理员信息 **/
        EditManager(id) {
            this.EditManagerInfos(id);
        }, 


        /** 管理员角色管理 **/
        ManagerRole() {
            this.roleshow=true;
        },


        /** 角色管理回调函数 **/
        GetRoleRollback() {
            this.roleshow=false;
            this.GetManagerInfo();
        },


        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作

        /** 获取管理员信息详情 **/
        GetManagerInfo() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-manager-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MANAGER.GET_MANAGER_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.managerlist=res.data.list;
            });
        },


        /** 新增管理员信息 **/
        AddManager() {
            var navinfo={name:'新增管理员',labelentry:'AddManager',components:'AddManager',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑管理员信息 **/
        EditManagerInfos(ids) {
            var navinfo={name:'编辑管理员',labelentry:'EditManager',components:'EditManager',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.managerlist.length;i++) this.managerlist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.managerlist);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.managerlist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 获取列表显示 **/
        Getpagelabel(isfresh=false) {
            this.$method.GET_PAGE_LABEL_SETTING('manager',isfresh).then((res) => {
                this.pagelabel=res ? res : {};
            });
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-info {display:inline-flex;align-items: center;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-isadmin {
    position:absolute;
    bottom:0;
    right:0;
    margin-right:-5px;
    width:25px;
    height:25px;
    border-radius: 50%;
    background-color: #ffffff;
    background-image:url(@/assets/icon/isadmin.png);
    background-repeat: no-repeat;
    background-size: 20px;
    background-position: center;
}
.TTL-manager-info {
    display:inline-flex;
    align-items:center;
    height: 60px;
    margin-left:20px;
}
.TTL-manager-info-out {
    display:inline-block;
    width:100%;
}
.TTL-manager-info-name {
    display: inline-block;
    width:100%;
    font-weight: 550;
    letter-spacing: 1px;
}
.TTL-manager-info-group {
    display: inline-block;
    width:100%;
    font-size:12px;
    color:#999999;
}
.TTL-btn-list {display:inline-flex;}
</style>